/**
 * 1등급 메인 홈페이지 (PC 영업 랜딩 + 앱 다운로드 유도)
 * - 레퍼런스: edudongne.com(동네학원), payssam.kr(결제선생) 룩앤필 재현
 * - 디자인 토큰: 파랑 주조색 + 흰/연회색 교차, 버튼 r8 / 카드 r14, 약한 그림자, 라인 아이콘(이모지 X)
 * - PC 기준 + 반응형(모바일 stack). 라우트: /intro
 * - 스크린샷 자리는 CSS 목업 → 추후 실제 앱 캡처로 교체
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  FiUserCheck, FiCreditCard, FiSmartphone, FiMapPin,
  FiCheck, FiPlus,
  FiArrowRight, FiMonitor, FiBell, FiX,
} from 'react-icons/fi';
import { QRCodeSVG } from 'qrcode.react';
import CompanyFooter from '../../components/common/CompanyFooter';
import { APP_STORE_URL, PLAY_STORE_URL, mobileStoreUrl, downloadSmartUrl } from '../../config/storeLinks';
import consoleDash from '../../assets/landing/console-dash.png';
import detail1 from '../../assets/landing/detail-1.png';
import detail2 from '../../assets/landing/detail-2.png';
import detail3 from '../../assets/landing/detail-3.png';
import detail4 from '../../assets/landing/detail-4.png';
import painAttendance from '../../assets/landing/pain-attendance.svg';
import painBilling from '../../assets/landing/pain-billing.svg';
import painChat from '../../assets/landing/pain-chat.svg';
import featAttendance from '../../assets/landing/feat-attendance.svg';
import featPayment from '../../assets/landing/feat-payment.svg';
import featParent from '../../assets/landing/feat-parent.svg';
import featPromo from '../../assets/landing/feat-promo.svg';
import alimtalkReal from '../../assets/landing/alimtalk-real.png';
import kioskCheckin from '../../assets/landing/kiosk-checkin.png';
import acaPiano from '../../assets/landing/academy/aca-piano.jpg';
import acaMath from '../../assets/landing/academy/aca-math.jpg';
import acaEnglish from '../../assets/landing/academy/aca-english.jpg';
import acaArt from '../../assets/landing/academy/aca-art.jpg';


const STATS = [
  { num: '0.8%', label: '학원비 결제 수수료' },
  { num: '0원', label: '알림톡 발송 비용' },
  { num: '5분', label: '가입부터 시작까지' },
  { num: '무제한', label: '학생·반 등록' },
];

// 함께하는 학원 (자동 슬라이드) — 경희 피아노 외 샘플(추후 실제 학원으로 교체)
const ACADEMIES = [
  { name: '경희 피아노', cat: '피아노', area: '남양주 다산', rating: '4.9', reviews: 16, img: acaPiano },
  { name: '다산 수학연구소', cat: '수학', area: '남양주 다산', rating: '4.8', reviews: 23, img: acaMath },
  { name: '하늘 영어학원', cat: '영어', area: '구리 수택', rating: '5.0', reviews: 31, img: acaEnglish },
  { name: '미술하는 아이들', cat: '미술', area: '남양주 진접', rating: '4.9', reviews: 12, img: acaArt },
];

// 수강후기(도입 후기) — 원장·학부모 (샘플, 추후 실제 후기로 교체)
const REVIEWS = [
  { title: '출결·알림이 자동이라 편해요', text: '버튼 한 번이면 등·하원 알림이 학부모님께 바로 가요. 저녁마다 따로 연락하던 게 사라졌어요.', author: '경희 피아노 원장' },
  { title: '정산 스트레스가 없어졌어요', text: '현금·카드 섞여서 헷갈리던 학원비가 앱에서 한 번에 정리되니 매달 편합니다.', author: '다산 수학연구소 원장' },
  { title: '학부모 만족도가 올랐어요', text: '오늘 수업 사진이랑 성적을 매일 받아보니 학부모님들이 정말 좋아하세요.', author: '하늘 영어학원 원장' },
  { title: '공부방도 쓸 수 있어 좋아요', text: '사업자 없는 작은 교습소인데도 무료로 바로 시작할 수 있었어요.', author: '리듬 발레 원장' },
  { title: '아이 학원 생활이 한눈에', text: '출석부터 성적까지 폰으로 바로 확인되니 안심이 돼요. 매일 들어가 봐요.', author: '초2 학부모' },
  { title: '선생님과 소통이 편해요', text: '궁금한 건 채팅으로 바로 여쭤봐요. 답도 빠르고 기록이 남아서 좋아요.', author: '6세 학부모' },
  { title: '광고 없이 문의가 늘었어요', text: '동네 검색에 우리 학원이 노출돼서 신규 상담 전화가 눈에 띄게 늘었습니다.', author: '미술하는 아이들 원장' },
  { title: '도입이 5분이면 끝나요', text: '복잡한 설치 없이 정보만 넣으니 우리 학원 페이지가 바로 완성됐어요.', author: '한빛 태권도 원장' },
];

const PAIN_POINTS = [
  { art: painAttendance, title: '번거로운 출결 관리', desc: '수기 출석부와 일일이 확인하는 등·하원 체크에 시간을 뺏기고 있진 않으세요?' },
  { art: painBilling, title: '복잡한 학원비 정산', desc: '현금·카드·이체가 뒤섞여 매달 정산하느라 골치 아프셨죠.' },
  { art: painChat, title: '학부모 소통 부담', desc: '한 분 한 분 따로 연락하느라 저녁마다 휴대폰을 붙잡고 계셨을 거예요.' },
];

const FEATURES = [
  {
    Icon: FiUserCheck,
    tag: '출결관리',
    color: '#4A7CFE',
    art: featAttendance,
    soft: '#EEF3FF',
    title: '등·하원을 한 번에, 알림은 자동으로',
    desc: '버튼 한 번으로 출결 체크. 학부모에게는 도착·귀가 알림이 실시간으로 전송됩니다.',
    points: ['버튼·QR 간편 체크인', '등·하원 시간 자동 기록', '학부모 실시간 알림톡(무료)'],
  },
  {
    Icon: FiCreditCard,
    tag: '결제관리',
    color: '#16A34A',
    art: featPayment,
    soft: '#EAF7EF',
    title: '학부모는 앱에서 결제, 정산은 내 계좌로',
    desc: '청구서를 보내면 학부모가 앱에서 바로 결제합니다. 수수료는 0.8%, 정산은 원장님 계좌로 직접 들어옵니다.',
    points: ['결제 수수료 0.8% (결제선생과 동일)', '앱 안에서 원클릭 결제', '내 계좌 직접 정산'],
  },
  {
    Icon: FiSmartphone,
    tag: '학부모앱',
    color: '#7C5CFC',
    art: featParent,
    soft: '#F2ECFE',
    title: '학부모가 매일 여는 우리 학원 채널',
    desc: '오늘의 수업, 사진, 선생님 메모, 성적까지. "키즈노트의 학원판"으로 학부모 만족도를 높이세요.',
    points: ['오늘의 수업·사진·메모', '성적·숙제 자동 정리', '선생님과 1:1 채팅'],
  },
  {
    Icon: FiMapPin,
    tag: '학원홍보',
    color: '#F59E0B',
    art: featPromo,
    soft: '#FEF4E4',
    title: '동네 학부모에게 먼저 발견되는 학원',
    desc: '학부모가 동네 학원을 찾을 때 지도와 검색에 우리 학원이 노출됩니다. 따로 광고비를 쓰지 않아도 됩니다.',
    points: ['동네 학원 지도·검색 노출', '학원 소개·사진·영상 페이지', '학부모 후기로 신뢰 쌓기'],
  },
];

// 학부모가 보는 학원 상세 화면을 한 섹션씩 보여주며 옆에 뜨는 도움말 (자동 스크롤 투어)
const DETAIL_TOUR = [
  { side: 'right', title: '사진 몇 장이면 끝', desc: '대표 사진과 한 줄 소개만 올리면, 학원에 와 본 적 없는 학부모도 우리 학원 분위기를 한눈에 느껴요. 전화·찜·공유도 화면에서 바로.' },
  { side: 'left', title: '궁금한 정보 한눈에', desc: '과목·수업 대상·영업시간·학원비까지 학부모가 가장 궁금해하는 정보가 깔끔하게 정리돼, 문의 전에 이미 신뢰가 생겨요.' },
  { side: 'right', title: '우리 학원만의 강점', desc: '원장님의 경력과 교육 철학, 우리 학원만의 차별점을 자유롭게 적어 주변 다른 학원과 확실히 구분돼요.' },
  { side: 'left', title: '후기가 신뢰를 만들어요', desc: '실제 다니는 학부모의 만족도와 생생한 후기가 쌓여, 새 학부모가 망설임 없이 우리 학원을 선택하게 도와줘요.' },
];

const DIFFS = [
  { label: '이용 대상', other: '사업자 등록 학원만', ours: '학원 · 공부방 · 개인 레슨까지' },
  { label: '학원비 결제 수수료', other: '0.8% + 별도 가입', ours: '0.8% · 앱 안에서 원클릭' },
  { label: '알림톡 발송 비용', other: '건당 약 100원', ours: '무료 (1등급 부담)' },
  { label: '학부모 앱', other: '청구서 정도', ours: '알림장·결제·커뮤니티 통합' },
  { label: '학원 홍보', other: '별도 광고비', ours: '지도·검색 노출 기본 제공' },
];

const FAQS = [
  { q: '1등급이 무엇인가요?', a: '학원 운영(출결·결제·성적·소통)과 학부모 앱을 하나로 묶은 통합 서비스입니다. 원장님은 학원을 관리하고, 학부모는 매일 우리 학원 소식을 받아봅니다.' },
  { q: '도입 비용이 있나요?', a: '가입과 기본 사용은 무료로 시작할 수 있습니다. 학원비 결제 수수료(0.8%)만 발생하며, 알림톡 발송 비용은 1등급이 부담합니다.' },
  { q: '학원이 아니어도 쓸 수 있나요?', a: '네. 사업자 등록이 안 된 공부방·개인 레슨·방문 교습 선생님도 누구나 무료로 시작할 수 있습니다.' },
  { q: '기존 학생 데이터를 옮길 수 있나요?', a: '학생·반·수강료 정보를 일괄로 등록할 수 있도록 도와드립니다. 고객센터로 문의 주세요.' },
  { q: '모바일에서도 쓸 수 있나요?', a: 'iOS·Android 앱과 PC 웹을 모두 지원합니다. 원장님은 PC로 관리하고 학부모는 앱으로 확인하는 식으로 함께 사용할 수 있습니다.' },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(0);
  const [qrOpen, setQrOpen] = useState(false);

  // 앱 다운로드: 모바일은 그 기기 스토어로 직행, PC는 QR 모달
  const handleDownload = () => {
    const store = mobileStoreUrl();
    if (store) {
      window.location.href = store;
    } else {
      setQrOpen(true);
    }
  };

  return (
    <Page data-fullwidth>
      {/* 헤더 */}
      <Header>
        <Inner>
          <Nav>
            <Logo onClick={() => navigate('/intro')}>일등급</Logo>
            <Menu>
              <a href="#features">핵심 기능</a>
              <a href="#diff">왜 일등급</a>
              <a href="#download">앱 다운로드</a>
              <a href="#faq">자주 묻는 질문</a>
            </Menu>
            <NavBtns>
              <ConsoleLink onClick={() => navigate('/console')}>
                <FiMonitor /> 원장님 PC 콘솔
              </ConsoleLink>
              <PrimaryBtn type="button" onClick={handleDownload}>앱 다운로드</PrimaryBtn>
            </NavBtns>
          </Nav>
        </Inner>
      </Header>

      {/* 1. 히어로 */}
      <Hero>
        <Inner>
          <HeroText>
            <Badge>학원 · 공부방 · 개인 레슨 누구나</Badge>
              <H1>
                학원 운영도, 학부모 소통도<br />
                <Accent>일등급</Accent> 하나로.
              </H1>
              <Lead>
                출결, 학원비 결제, 성적, 학부모 알림을 한 곳에서.<br />
                학부모가 매일 여는 앱으로 우리 학원을 알리세요.
              </Lead>
              <HeroBtns>
                <PrimaryBtn $lg type="button" onClick={handleDownload}>앱 다운로드</PrimaryBtn>
                <OutlineBtn $lg as="a" href="#features">기능 둘러보기</OutlineBtn>
              </HeroBtns>
              <SubNote>가입·기본 사용 무료 · 알림톡 무료 제공</SubNote>
            </HeroText>

            {/* 학원 운영(PC 콘솔) + 학부모 앱 목업 */}
            <HeroVisual>
              <Stage>
                {/* PC 모니터 — 학원 운영(원장 콘솔) */}
                <Monitor>
                  <MScreen>
                    <DApp>
                      <DashImg src={consoleDash} alt="일등급 학원 운영 콘솔 대시보드" />
                    </DApp>
                  </MScreen>
                  <MNeck />
                  <MFoot />
                </Monitor>

                {/* 학부모 앱 — 폰 목업 (등원/결제 알림 + 오늘의 수업) */}
                <PhoneWrap>
                  <PhoneFrame>
                    <PhoneNotch />
                    <PhoneScreen aria-label="일등급 학부모 앱 미리보기">
                      <MockHeader>
                        <MockDot /> 우리 학원
                      </MockHeader>
                      <MockNoti $c="#4A7CFE">
                        <FiBell />
                        <div>
                          <b>김민준 학생 등원</b>
                          <span>오후 3:02 · 영어 A반</span>
                        </div>
                      </MockNoti>
                      <MockNoti $c="#16A34A">
                        <FiCreditCard />
                        <div>
                          <b>5월 수강료 결제 완료</b>
                          <span>180,000원 · 카드</span>
                        </div>
                      </MockNoti>
                      <MockCard>
                        <MockCardTitle>오늘의 수업</MockCardTitle>
                        <MockLine $w="90%" />
                        <MockLine $w="70%" />
                        <MockThumb />
                      </MockCard>
                    </PhoneScreen>
                  </PhoneFrame>
                </PhoneWrap>
              </Stage>
            </HeroVisual>
        </Inner>
      </Hero>

      {/* 2. 통계 바 */}
      <StatsBar>
        <Inner>
          <StatsGrid>
            {STATS.map((s) => (
              <Stat key={s.label}>
                <StatNum>{s.num}</StatNum>
                <StatLabel>{s.label}</StatLabel>
              </Stat>
            ))}
          </StatsGrid>
        </Inner>
      </StatsBar>

      {/* 함께하는 학원 — 자동 슬라이드 */}
      <Partners>
        <Inner>
          <Eyebrow>이미 일등급으로 시작한 학원들</Eyebrow>
          <SectionTitle>일등급과 함께하는 학원</SectionTitle>
        </Inner>
        <Marquee>
          <MTrack>
            {[...ACADEMIES, ...ACADEMIES].map((a, i) => (
              <SlideCard key={`${a.name}-${i}`}>
                <SlideThumb $img={a.img}>
                  <SlideCat>{a.cat}</SlideCat>
                  <SlideName>{a.name}</SlideName>
                </SlideThumb>
                <SlideBody>
                  <SlideMeta>{a.area} · {a.cat}</SlideMeta>
                  <SlideRate><Star>★</Star> {a.rating} <SlideReviews>후기 {a.reviews}</SlideReviews></SlideRate>
                </SlideBody>
              </SlideCard>
            ))}
          </MTrack>
        </Marquee>
      </Partners>

      {/* 3. 학원 홍보 (사진 갤러리 + 설명) */}
      <Section>
        <Inner>
          <Eyebrow>큰 학원이 아니어도 괜찮아요</Eyebrow>
          <SectionTitle>광고비 없이도, 동네 학부모가 먼저 찾는 학원</SectionTitle>
          <WhoLead>
            혼자 가르치는 작은 학원·개인교습소도 사진 몇 장으로 우리 학원만의 매력을 보여줄 수 있어요.
            일등급이 동네 학부모에게 무료로 소개해 드립니다.
          </WhoLead>
          {/* 학부모가 보는 학원 상세 화면 — 자동 스크롤 + 섹션별 도움말 투어 */}
          <DetailTour aria-label="학부모가 보는 학원 상세 화면 둘러보기">
            <DTPhone>
              <DTNotch />
              <DTScreen>
                <DTTrack>
                  {/* 실제 학원 상세 화면 스크린샷 4장 — 섹션별로 한 화면씩 */}
                  <DTPanel><DTShot src={detail1} alt="학원 사진과 소개" /></DTPanel>
                  <DTPanel><DTShot src={detail2} alt="수업 정보와 학원비" /></DTPanel>
                  <DTPanel><DTShot src={detail3} alt="학원 상세 소개" /></DTPanel>
                  <DTPanel><DTShot src={detail4} alt="학부모 솔직 후기" /></DTPanel>
                </DTTrack>
              </DTScreen>
            </DTPhone>

            {DETAIL_TOUR.map((c, i) => (
              <DTCallout key={c.title} $side={c.side} $i={i}>
                <DTCalloutTitle>{c.title}</DTCalloutTitle>
                <DTCalloutDesc>{c.desc}</DTCalloutDesc>
              </DTCallout>
            ))}
          </DetailTour>
        </Inner>
      </Section>

      {/* 4. 공감 (원장님 고민) */}
      <Section $alt>
        <Inner>
          <Eyebrow>원장님, 이런 고민 있으셨죠?</Eyebrow>
          <SectionTitle>혼자 다 하기엔 너무 많은 학원 일</SectionTitle>
          <Cards3>
            {PAIN_POINTS.map(({ art, title, desc }) => (
              <PainCard key={title}>
                <PainArt src={art} alt="" />
                <PainTitle>{title}</PainTitle>
                <PainDesc>{desc}</PainDesc>
              </PainCard>
            ))}
          </Cards3>
        </Inner>
      </Section>

      {/* 5. 핵심기능 */}
      <Section id="features">
        <Inner>
          <Eyebrow>핵심 기능</Eyebrow>
          <SectionTitle>학원 운영에 필요한 모든 것</SectionTitle>
          <FeatureList>
            {FEATURES.map((f, i) => (
              <FeatureRow key={f.title} $reverse={i % 2 === 1}>
                <FeatureVisual>
                  <FeatureArtCard $bg={f.soft}>
                    <FeatureArt src={f.art} alt="" />
                  </FeatureArtCard>
                </FeatureVisual>
                <FeatureBody>
                  <FeatureTag $c={f.color}>{f.tag}</FeatureTag>
                  <FeatureTitle>{f.title}</FeatureTitle>
                  <FeatureDesc>{f.desc}</FeatureDesc>
                  <PointList>
                    {f.points.map((pt) => (
                      <li key={pt}><Check $c={f.color}><FiCheck /></Check>{pt}</li>
                    ))}
                  </PointList>
                </FeatureBody>
              </FeatureRow>
            ))}
          </FeatureList>
        </Inner>
      </Section>

      {/* 5.5 실제 작동 흐름 — 키오스크 체크인 → 학부모 알림톡 */}
      <Section $alt>
        <Inner>
          <Eyebrow>실제로 이렇게 작동해요</Eyebrow>
          <SectionTitle>뒷번호 입력 한 번이면, 학부모 카톡까지 자동으로</SectionTitle>
          <WhoLead>
            기기를 새로 살 필요 없어요. 학원에 있는 태블릿·스마트폰·PC 한 대로
            브라우저만 열면 바로 출석 체크가 시작됩니다.
          </WhoLead>
          <FlowRow>
            <FlowStep>
              <FlowShot src={kioskCheckin} alt="태블릿·폰 키오스크 — 전화번호 뒷자리로 출석 체크" />
              <FlowLabel><b>STEP 1</b>학생이 태블릿·폰에<br />전화 뒷자리 4자리 입력</FlowLabel>
            </FlowStep>
            <FlowArrow><FiArrowRight /></FlowArrow>
            <FlowStep>
              <FlowShot src={alimtalkReal} alt="학부모 카카오 알림톡 — 등원·하원 실시간 알림" />
              <FlowLabel><b>STEP 2</b>학부모에게 등·하원<br />알림톡이 자동 발송</FlowLabel>
            </FlowStep>
          </FlowRow>
        </Inner>
      </Section>

      {/* 6. 차별점 비교표 */}
      <Section id="diff" $alt>
        <Inner>
          <Eyebrow>왜 일등급일까요?</Eyebrow>
          <SectionTitle>수수료는 같게, 혜택은 더 크게</SectionTitle>
          <CompareTable>
            <CompareHead>
              <div />
              <CompareCol $muted>일반 학원 결제 서비스</CompareCol>
              <CompareCol $highlight>일등급</CompareCol>
            </CompareHead>
            {DIFFS.map((d) => (
              <CompareRow key={d.label}>
                <CompareLabel>{d.label}</CompareLabel>
                <CompareCell $muted>{d.other}</CompareCell>
                <CompareCell $highlight><FiCheck /> {d.ours}</CompareCell>
              </CompareRow>
            ))}
          </CompareTable>
        </Inner>
      </Section>

      {/* 수강후기 */}
      <Section id="reviews" $alt>
        <Inner>
          <Eyebrow>고객 후기</Eyebrow>
          <RatingRow>
            <BigStars>★★★★★</BigStars>
            <RatingScore>4.9</RatingScore>
          </RatingRow>
          <SectionTitle>일등급을 먼저 써본 분들</SectionTitle>
        </Inner>
        <ReviewMarquee>
          <ReviewTrack>
            {[...REVIEWS, ...REVIEWS].map((r, i) => (
              <ReviewCard key={`${r.title}-${i}`}>
                <Stars>★★★★★</Stars>
                <ReviewTitle>{r.title}</ReviewTitle>
                <ReviewText>{r.text}</ReviewText>
                <ReviewAuthor>{r.author}</ReviewAuthor>
              </ReviewCard>
            ))}
          </ReviewTrack>
        </ReviewMarquee>
      </Section>

      {/* 7. 앱 다운로드 CTA */}
      <Download id="download">
        <Inner>
          <DownloadTitle>지금 바로 시작해보세요</DownloadTitle>
          <DownloadLead>
            도입 비용 없이 무료로 시작. 학부모는 앱에서, 원장님은 PC·앱 어디서나.
          </DownloadLead>
          <StoreBtns>
            <StoreBtn href={APP_STORE_URL} target="_blank" rel="noreferrer">App Store</StoreBtn>
            <StoreBtn href={PLAY_STORE_URL} target="_blank" rel="noreferrer">Google Play</StoreBtn>
          </StoreBtns>
          <ConsoleNote>원장님은 PC에서 학원을 관리하세요</ConsoleNote>
          <WhiteBtn onClick={() => navigate('/console')}>
            학원 콘솔 바로가기 <FiArrowRight />
          </WhiteBtn>
        </Inner>
      </Download>

      {/* 8. FAQ */}
      <Section id="faq">
        <Inner $narrow>
          <Eyebrow>자주 묻는 질문</Eyebrow>
          <SectionTitle>궁금한 점이 있으신가요?</SectionTitle>
          <FaqList>
            {FAQS.map((f, i) => (
              <FaqItem key={f.q}>
                <FaqQ onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                  <span>{f.q}</span>
                  <FaqToggle $open={openFaq === i}><FiPlus /></FaqToggle>
                </FaqQ>
                {openFaq === i && <FaqA>{f.a}</FaqA>}
              </FaqItem>
            ))}
          </FaqList>
        </Inner>
      </Section>

      {qrOpen && (
        <QrOverlay onClick={() => setQrOpen(false)}>
          <QrModal onClick={(e) => e.stopPropagation()}>
            <QrClose type="button" onClick={() => setQrOpen(false)} aria-label="닫기">
              <FiX />
            </QrClose>
            <QrTitle>1등급 앱으로 열기</QrTitle>
            <QrBox>
              <QRCodeSVG value={downloadSmartUrl()} size={196} level="M" />
            </QrBox>
            <QrHint>
              휴대폰 카메라로 QR을 찍으면<br />
              사용 중인 폰에 맞는 앱스토어로 이동합니다.
            </QrHint>
          </QrModal>
        </QrOverlay>
      )}

      <CompanyFooter />
    </Page>
  );
};

export default LandingPage;

/* ============ design tokens ============ */
const PRIMARY = '#7C5CFC';
const INK = '#1F2937';
const SUB = '#6B7280';
const LINE = '#E8ECF3';
const ALT_BG = '#F8FAFC';
const RADIUS_CARD = '14px';
const RADIUS_BTN = '8px';
const SHADOW = '0 2px 10px rgba(17, 24, 39, 0.06)';

const Page = styled.div`
  background: #fff;
  color: ${INK};
  font-size: 16px;
`;

const Inner = styled.div`
  width: 100%;
  max-width: ${({ $narrow }) => ($narrow ? '740px' : '1080px')};
  margin: 0 auto;
  padding: 0 24px;
`;

/* Header */
const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid ${LINE};
`;

const Nav = styled.nav`
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Logo = styled.div`
  font-size: 21px;
  font-weight: 800;
  color: ${PRIMARY};
  cursor: pointer;
  letter-spacing: -0.5px;
`;

const Menu = styled.div`
  display: flex;
  gap: 30px;
  a {
    font-size: 15px;
    font-weight: 500;
    color: #4B5563;
    text-decoration: none;
    &:hover { color: ${PRIMARY}; }
  }
  @media (max-width: 900px) { display: none; }
`;

const NavBtns = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ConsoleLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #4B5563;
  svg { font-size: 16px; }
  &:hover { color: ${PRIMARY}; }
  @media (max-width: 560px) { display: none; }
`;

const PrimaryBtn = styled.button`
  border: none;
  cursor: pointer;
  background: ${PRIMARY};
  color: #fff;
  font-weight: 700;
  font-size: ${({ $lg }) => ($lg ? '16px' : '14.5px')};
  padding: ${({ $lg }) => ($lg ? '14px 26px' : '10px 18px')};
  border-radius: ${RADIUS_BTN};
  text-decoration: none;
  display: inline-block;
  transition: background 0.15s, transform 0.12s;
  &:hover { background: #6A47E8; transform: translateY(-1px); }
  &:active { transform: translateY(0); }
`;

const OutlineBtn = styled.button`
  border: 1.5px solid #CBD5E8;
  cursor: pointer;
  background: #fff;
  color: #374151;
  font-weight: 700;
  font-size: ${({ $lg }) => ($lg ? '16px' : '14.5px')};
  padding: ${({ $lg }) => ($lg ? '13px 26px' : '9px 18px')};
  border-radius: ${RADIUS_BTN};
  text-decoration: none;
  display: inline-block;
  &:hover { border-color: ${PRIMARY}; color: ${PRIMARY}; }
`;

/* Hero */
const Hero = styled.section`
  background: linear-gradient(180deg, #F4F1FE 0%, #fff 100%);
  padding: 88px 0 40px;
  overflow: hidden;
`;

const HeroText = styled.div`
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
`;

const Badge = styled.span`
  display: inline-block;
  background: #EFEAFE;
  color: ${PRIMARY};
  font-size: 14px;
  font-weight: 700;
  padding: 7px 15px;
  border-radius: 999px;
  margin-bottom: 22px;
`;

const H1 = styled.h1`
  font-size: 52px;
  line-height: 1.22;
  font-weight: 800;
  color: #111827;
  letter-spacing: -1.4px;
  margin-bottom: 20px;
  @media (max-width: 900px) { font-size: 33px; }
`;

const Accent = styled.span`color: ${PRIMARY};`;

const Lead = styled.p`
  font-size: 18px;
  line-height: 1.7;
  color: ${SUB};
  margin-bottom: 30px;
  @media (max-width: 900px) { font-size: 16px; br { display: none; } }
`;

const HeroBtns = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const SubNote = styled.p`
  margin-top: 16px;
  font-size: 14px;
  color: #9CA3AF;
`;

/* 학원 운영(PC) + 학부모 앱 목업 */
const HeroVisual = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 72px;
  padding-bottom: 100px;
  @media (max-width: 900px) { margin-top: 48px; padding-bottom: 60px; }
`;

const Stage = styled.div`
  position: relative;
  width: 100%;
  max-width: 1040px;
`;

/* PC 모니터 */
const Monitor = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MScreen = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #E6EAF2;
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 24px 50px rgba(31, 45, 90, 0.18);
`;

const DApp = styled.div`
  width: 100%;
  background: #F6F8FC;
  border-radius: 8px;
  overflow: hidden;
`;

const DashImg = styled.img`
  width: 100%;
  display: block;
`;

const MNeck = styled.div`
  width: 64px;
  height: 20px;
  background: linear-gradient(#EAEDF3, #DCE0E9);
`;

const MFoot = styled.div`
  width: 150px;
  height: 12px;
  background: #DCE0E9;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 14px rgba(31, 45, 90, 0.12);
`;

/* 학부모 앱 폰 (PC 앞에 겹침) */
const PhoneWrap = styled.div`
  position: absolute;
  right: -24px;
  bottom: -44px;
  transform: scale(0.82);
  transform-origin: bottom right;
  z-index: 3;
  @media (max-width: 900px) {
    right: -8px;
    bottom: -26px;
    transform: scale(0.5);
  }
`;

/* 폰 목업 — 등원/결제 알림 + 오늘의 수업 카드 */
const PhoneFrame = styled.div`
  position: relative;
  width: 270px;
  height: 540px;
  border-radius: 38px;
  border: 8px solid #111827;
  background: #111827;
  box-shadow: 0 30px 60px rgba(31, 45, 90, 0.25);
  overflow: hidden;
`;

const PhoneNotch = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 22px;
  background: #111827;
  border-radius: 0 0 14px 14px;
  z-index: 2;
`;

const PhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  background: ${ALT_BG};
  border-radius: 28px;
  overflow: hidden;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const MockHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
  font-size: 16px;
  color: #111827;
  padding: 18px 4px 6px;
`;

const MockDot = styled.span`
  width: 26px; height: 26px;
  border-radius: 8px;
  background: ${PRIMARY};
`;

const MockNoti = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: ${SHADOW};
  svg { color: ${({ $c }) => $c}; font-size: 20px; flex-shrink: 0; }
  b { display: block; font-size: 13px; color: #111827; }
  span { display: block; font-size: 11px; color: #9CA3AF; margin-top: 2px; }
`;

const MockCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: ${SHADOW};
  flex: 1;
`;

const MockCardTitle = styled.p`
  font-size: 13px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 12px;
`;

const MockLine = styled.div`
  height: 9px;
  width: ${({ $w }) => $w || '100%'};
  background: #EDF1F7;
  border-radius: 5px;
  margin-bottom: 8px;
`;

const MockThumb = styled.div`
  margin-top: 10px;
  height: 70px;
  border-radius: 10px;
  background: linear-gradient(135deg, #DCE6FB, #EAF0FE);
`;

/* Stats */
const StatsBar = styled.section`
  background: ${PRIMARY};
  padding: 34px 0;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  @media (max-width: 700px) { grid-template-columns: repeat(2, 1fr); gap: 28px; }
`;

const Stat = styled.div`text-align: center;`;

const StatNum = styled.p`
  font-size: 34px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -1px;
  @media (max-width: 900px) { font-size: 28px; }
`;

const StatLabel = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 4px;
`;

/* 함께하는 학원 — 자동 슬라이드 */
const Partners = styled.section`
  padding: 84px 0;
  background: #fff;
  overflow: hidden;
`;

const Marquee = styled.div`
  margin-top: 6px;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
`;

const MTrack = styled.div`
  display: flex;
  gap: 22px;
  width: max-content;
  padding: 14px 24px;
  animation: partnersScroll 48s linear infinite;
  &:hover { animation-play-state: paused; }
  @keyframes partnersScroll {
    from { transform: translateX(0); }
    to { transform: translateX(calc(-50% - 11px)); }
  }
`;

const SlideCard = styled.div`
  width: 330px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid ${LINE};
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 12px 34px rgba(31, 45, 90, 0.08);
`;

const SlideThumb = styled.div`
  height: 210px;
  background-image:
    linear-gradient(to top, rgba(17, 24, 39, 0.66), rgba(17, 24, 39, 0.05) 48%, rgba(17, 24, 39, 0)),
    url(${({ $img }) => $img});
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 18px;
`;

const SlideCat = styled.span`
  position: absolute;
  top: 14px;
  left: 14px;
  background: rgba(255, 255, 255, 0.92);
  color: #374151;
  font-size: 12.5px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 999px;
`;

const SlideName = styled.span`
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.35);
`;

const SlideBody = styled.div`
  padding: 16px 18px 18px;
`;

const SlideMeta = styled.p`
  font-size: 14px;
  color: #6B7280;
  margin-bottom: 9px;
`;

const SlideRate = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #1F2937;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Star = styled.span`color: #F59E0B;`;

const SlideReviews = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #9CA3AF;
  margin-left: 4px;
`;

/* 수강후기 평균 별점 뱃지 */
const RatingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 14px;
`;

const BigStars = styled.span`
  color: #F59E0B;
  font-size: 26px;
  letter-spacing: 3px;
`;

const RatingScore = styled.span`
  font-size: 26px;
  font-weight: 800;
  color: #1F2937;
`;

/* 수강후기 — 한 줄 무한 슬라이드 (4개씩 보임) */
const ReviewMarquee = styled.div`
  margin-top: 4px;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 5%, #000 95%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 5%, #000 95%, transparent);
`;

const ReviewTrack = styled.div`
  display: flex;
  gap: 18px;
  width: max-content;
  padding: 14px 24px;
  animation: reviewsScroll 55s linear infinite;
  &:hover { animation-play-state: paused; }
  @keyframes reviewsScroll {
    from { transform: translateX(0); }
    to { transform: translateX(calc(-50% - 9px)); }
  }
`;

const ReviewCard = styled.div`
  width: 280px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid ${LINE};
  border-radius: 14px;
  padding: 22px 20px;
  box-shadow: ${SHADOW};
  display: flex;
  flex-direction: column;
  @media (max-width: 600px) { width: 260px; }
`;

const Stars = styled.div`
  color: #F59E0B;
  font-size: 15px;
  letter-spacing: 2px;
  margin-bottom: 12px;
`;

const ReviewTitle = styled.h4`
  font-size: 15.5px;
  font-weight: 800;
  color: #1F2937;
  margin-bottom: 9px;
  line-height: 1.35;
`;

const ReviewText = styled.p`
  font-size: 14px;
  line-height: 1.65;
  color: ${SUB};
  margin-bottom: 16px;
  flex: 1;
`;

const ReviewAuthor = styled.p`
  font-size: 12.5px;
  font-weight: 600;
  color: #9CA3AF;
`;

/* Section */
const Section = styled.section`
  padding: 84px 0;
  background: ${({ $alt }) => ($alt ? ALT_BG : '#fff')};
`;

const Eyebrow = styled.p`
  text-align: ${({ $left }) => ($left ? 'left' : 'center')};
  font-size: 15px;
  font-weight: 700;
  color: ${PRIMARY};
  margin-bottom: 12px;
  @media (max-width: 900px) { text-align: center; }
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 32px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.8px;
  margin-bottom: 50px;
  @media (max-width: 900px) { font-size: 25px; }
`;

/* 학원 홍보 (사진 갤러리 + 설명) */
const WhoLead = styled.p`
  text-align: center;
  font-size: 17px;
  line-height: 1.7;
  color: ${SUB};
  max-width: 640px;
  margin: -34px auto 46px;
  @media (max-width: 900px) { font-size: 15.5px; }
`;

/* ── 학원 상세 화면 자동 스크롤 투어 + 도움말 ───────────────── */
const DetailTour = styled.div`
  position: relative;
  width: 100%;
  max-width: 1000px;
  margin: 6px auto 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 900px) {
    margin-bottom: 156px;
  }
`;

const DTPhone = styled.div`
  position: relative;
  z-index: 2;
  width: 392px;
  flex: 0 0 392px;
  padding: 11px;
  background: #111827;
  border-radius: 48px;
  box-shadow: 0 34px 70px rgba(31, 45, 90, 0.28);
  @media (max-width: 900px) {
    width: 300px;
    flex-basis: 300px;
    padding: 10px;
    border-radius: 42px;
  }
`;

const DTNotch = styled.div`
  position: absolute;
  top: 17px;
  left: 50%;
  transform: translateX(-50%);
  width: 128px;
  height: 24px;
  background: #111827;
  border-radius: 0 0 16px 16px;
  z-index: 4;
  @media (max-width: 900px) { width: 110px; height: 22px; }
`;

const DTScreen = styled.div`
  --vh: 700px;
  position: relative;
  height: var(--vh);
  background: #fff;
  border-radius: 38px;
  overflow: hidden;
  @media (max-width: 900px) { --vh: 500px; border-radius: 32px; }

  /* 실제 스샷 4장을 쌓아 연속 스크롤. 끝은 마지막 장 바닥이 화면 바닥에 딱 맞게 */
  @keyframes dtScroll {
    0%, 6%    { transform: translateY(0); }
    86%, 92%  { transform: translateY(calc(-100% + var(--vh))); }
    100%      { transform: translateY(0); }
  }
`;

const DTTrack = styled.div`
  display: flex;
  flex-direction: column;
  animation: dtScroll 28s cubic-bezier(0.45, 0, 0.2, 1) infinite;
`;

const DTPanel = styled.div`
  width: 100%;
`;

const DTShot = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const CALLOUT_BG = '#FFE27A';

const DTCallout = styled.div`
  position: absolute;
  z-index: 3;
  width: 264px;
  top: ${({ $i }) => 104 + $i * 40}px;
  ${({ $side }) => ($side === 'right' ? 'right: 0;' : 'left: 0;')}
  padding: 16px 18px 17px;
  background: ${CALLOUT_BG};
  border: 1px solid #F2CE45;
  border-radius: 16px;
  box-shadow: 0 18px 42px rgba(214, 170, 30, 0.32);
  opacity: 0;
  animation: ${({ $i }) => `dtCall${$i}`} 28s ease-in-out infinite;

  &::after {
    content: '';
    position: absolute;
    top: 28px;
    ${({ $side }) => ($side === 'right'
      ? `left: -8px; border-width: 7px 9px 7px 0; border-color: transparent ${CALLOUT_BG} transparent transparent;`
      : `right: -8px; border-width: 7px 0 7px 9px; border-color: transparent transparent transparent ${CALLOUT_BG};`)}
    border-style: solid;
    filter: drop-shadow(${({ $side }) => ($side === 'right' ? '-1px' : '1px')} 0 0 #F2CE45);
  }

  @keyframes dtCall0 { 0%,4%{opacity:0} 9%,22%{opacity:1} 26%,100%{opacity:0} }
  @keyframes dtCall1 { 0%,28%{opacity:0} 32%,44%{opacity:1} 48%,100%{opacity:0} }
  @keyframes dtCall2 { 0%,48%{opacity:0} 52%,64%{opacity:1} 68%,100%{opacity:0} }
  @keyframes dtCall3 { 0%,68%{opacity:0} 72%,84%{opacity:1} 88%,100%{opacity:0} }

  @media (max-width: 900px) {
    top: auto;
    bottom: -126px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: 90%;
    max-width: 340px;
    text-align: center;
    &::after { display: none; }
  }
`;

const DTCalloutTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14.5px;
  font-weight: 800;
  color: #1A1A1A;
  margin-bottom: 6px;
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #1A1A1A;
    flex: none;
  }
  @media (max-width: 900px) { justify-content: center; }
`;

const DTCalloutDesc = styled.div`
  font-size: 12.5px;
  line-height: 1.6;
  color: #2A2A2A;
`;

/* Pain */
const Cards3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

const PainCard = styled.div`
  background: #fff;
  border: 1px solid ${LINE};
  border-radius: ${RADIUS_CARD};
  padding: 32px 26px;
  box-shadow: ${SHADOW};
`;

const PainArt = styled.img`
  display: block;
  width: 168px;
  height: auto;
  margin: -4px 0 16px -8px;
`;

const PainTitle = styled.h3`
  font-size: 19px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px;
`;

const PainDesc = styled.p`
  font-size: 15px;
  line-height: 1.7;
  color: ${SUB};
`;

/* Features */
const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const FeatureRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;
  align-items: center;
  direction: ${({ $reverse }) => ($reverse ? 'rtl' : 'ltr')};
  & > * { direction: ltr; }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    direction: ltr;
    gap: 28px;
  }
`;

const FeatureVisual = styled.div``;
const FeatureBody = styled.div``;

/* 기능 일러스트 카드 */
const FeatureArtCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${RADIUS_CARD};
  background: ${({ $bg }) => $bg};
  border: 1px solid ${LINE};
  padding: 30px 34px;
`;

const FeatureArt = styled.img`
  width: 100%;
  max-width: 360px;
  height: auto;
  display: block;
`;

const FeatureTag = styled.span`
  display: inline-block;
  background: ${({ $c }) => `${$c}14`};
  color: ${({ $c }) => $c};
  font-size: 13px;
  font-weight: 700;
  padding: 6px 13px;
  border-radius: 999px;
  margin-bottom: 16px;
`;

const FeatureTitle = styled.h3`
  font-size: 27px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 14px;
  letter-spacing: -0.6px;
  line-height: 1.35;
`;

const FeatureDesc = styled.p`
  font-size: 16.5px;
  line-height: 1.7;
  color: ${SUB};
  margin-bottom: 24px;
`;

const PointList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 13px;
  li {
    display: flex;
    align-items: center;
    gap: 11px;
    font-size: 16px;
    font-weight: 600;
    color: #374151;
  }
`;

const Check = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px; height: 24px;
  border-radius: 50%;
  background: ${({ $c }) => `${$c}1A`};
  color: ${({ $c }) => $c};
  font-size: 14px;
  flex-shrink: 0;
`;

/* 실제 작동 흐름 — 키오스크 → 알림톡 */
const FlowRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  max-width: 900px;
  margin: 0 auto;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 26px;
  }
`;

const FlowStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  flex: 1;
  max-width: 300px;
`;

const FlowShot = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 18px;
  border: 1px solid ${LINE};
  box-shadow: ${SHADOW};
`;

const FlowLabel = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  line-height: 1.55;
  b {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.5px;
    color: ${PRIMARY};
  }
`;

const FlowArrow = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: ${PRIMARY};
  font-size: 32px;
  margin-bottom: 44px;
  @media (max-width: 900px) {
    transform: rotate(90deg);
    margin-bottom: 0;
  }
`;

/* Compare */
const CompareTable = styled.div`
  max-width: 820px;
  margin: 0 auto;
  border: 1px solid ${LINE};
  border-radius: ${RADIUS_CARD};
  overflow: hidden;
  background: #fff;
  box-shadow: ${SHADOW};
`;

const CompareHead = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1fr 1.1fr;
  background: #F1F4F9;
  border-bottom: 1px solid ${LINE};
`;

const CompareCol = styled.div`
  padding: 18px 16px;
  text-align: center;
  font-weight: 800;
  font-size: 16px;
  color: ${({ $highlight, $muted }) => ($highlight ? PRIMARY : $muted ? '#9CA3AF' : '#374151')};
  background: ${({ $highlight }) => ($highlight ? '#F1ECFE' : 'transparent')};
`;

const CompareRow = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1fr 1.1fr;
  border-bottom: 1px solid #F1F4F9;
  &:last-child { border-bottom: none; }
`;

const CompareLabel = styled.div`
  padding: 17px 16px;
  font-weight: 700;
  font-size: 15px;
  color: #374151;
  background: #FBFCFE;
`;

const CompareCell = styled.div`
  padding: 17px 16px;
  text-align: center;
  font-size: 14.5px;
  font-weight: ${({ $highlight }) => ($highlight ? 700 : 500)};
  color: ${({ $highlight, $muted }) => ($highlight ? '#1C2E54' : $muted ? '#9CA3AF' : SUB)};
  background: ${({ $highlight }) => ($highlight ? '#F7F4FE' : 'transparent')};
  svg { color: ${PRIMARY}; vertical-align: -2px; margin-right: 2px; }
`;

/* Download */
const Download = styled.section`
  background: linear-gradient(135deg, ${PRIMARY} 0%, #9B82FD 100%);
  padding: 84px 0;
  text-align: center;
  color: #fff;
`;

const DownloadTitle = styled.h2`
  font-size: 34px;
  font-weight: 800;
  letter-spacing: -0.8px;
  margin-bottom: 16px;
  @media (max-width: 900px) { font-size: 26px; }
`;

const DownloadLead = styled.p`
  font-size: 18px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 32px;
  @media (max-width: 900px) { font-size: 16px; }
`;

const StoreBtns = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 22px;
  flex-wrap: wrap;
`;

const StoreBtn = styled.a`
  background: #111827;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  padding: 14px 30px;
  border-radius: ${RADIUS_BTN};
  text-decoration: none;
  &:hover { background: #000; }
`;

const ConsoleNote = styled.p`
  font-size: 15px;
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 14px;
`;

const WhiteBtn = styled.button`
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  padding: 12px 24px;
  border-radius: ${RADIUS_BTN};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  &:hover { background: rgba(255, 255, 255, 0.26); }
`;

/* FAQ */
const FaqList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FaqItem = styled.div`
  border: 1px solid ${LINE};
  border-radius: ${RADIUS_CARD};
  background: #fff;
  overflow: hidden;
`;

const FaqQ = styled.button`
  width: 100%;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 22px;
  font-size: 17px;
  font-weight: 700;
  color: #1F2937;
  text-align: left;
`;

const FaqToggle = styled.span`
  display: inline-flex;
  color: ${PRIMARY};
  font-size: 20px;
  transition: transform 0.2s;
  transform: rotate(${({ $open }) => ($open ? '135deg' : '0')});
`;

const FaqA = styled.div`
  padding: 0 22px 22px;
  font-size: 15.5px;
  line-height: 1.75;
  color: ${SUB};
`;

/* 앱 다운로드 QR 모달 (PC 전용) */
const QrOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(17, 24, 39, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const QrModal = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 18px;
  padding: 36px 28px 30px;
  text-align: center;
  box-shadow: 0 18px 50px rgba(17, 24, 39, 0.25);
`;

const QrClose = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: #F3F4F6;
  color: ${INK};
  font-size: 20px;
  cursor: pointer;
  &:hover { background: #E5E7EB; }
`;

const QrTitle = styled.p`
  font-size: 20px;
  font-weight: 800;
  color: ${INK};
  margin-bottom: 22px;
`;

const QrBox = styled.div`
  display: inline-flex;
  padding: 16px;
  background: #fff;
  border: 1px solid ${LINE};
  border-radius: 16px;
  margin-bottom: 18px;
`;

const QrHint = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: ${SUB};
`;
